import { createRoute } from '@/utils/routing'

export const SWIFT_MESSAGE_LIST_ROUTE = 'swift-messages'
export const SWIFT_MESSAGE_VIEW_V1_ROUTE = 'swift-messages-messageCloudReference'
export const SWIFT_MESSAGE_VIEW_V2_ROUTE = 'swift-messages-swiftMessageId-v2'
export const SWIFT_MESSAGE_REPLY_ROUTE = 'swift-messages-swiftMessageId-reply'

function createRouteWithSwiftMessageId (name, swiftMessageId, options) {
  if (swiftMessageId != null) {
    return createRoute(name, {
      params: { ...options.params, swiftMessageId },
      query: options.query
    })
  }
}

export function createSwiftMessageListRoute (options = {}) {
  return createRoute(SWIFT_MESSAGE_LIST_ROUTE, options)
}

export function createSwiftMessageViewV1Route (messageCloudReference, options = {}) {
  if (messageCloudReference != null) {
    return createRoute(SWIFT_MESSAGE_VIEW_V1_ROUTE, {
      params: { ...options.params, messageCloudReference },
      query: options.query
    })
  }
}

export function createSwiftMessageViewV2Route (swiftMessageId, options = {}) {
  return createRouteWithSwiftMessageId(SWIFT_MESSAGE_VIEW_V2_ROUTE, swiftMessageId, options)
}

export function createSwiftMessageReplyRoute (swiftMessageId, options = {}) {
  return createRouteWithSwiftMessageId(SWIFT_MESSAGE_REPLY_ROUTE, swiftMessageId, options)
}
